import $ from "jquery";

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';
import Vars from "../../vars";

class Cash {
    constructor (args) {
        let self = this;

        self._state.mode  = args.mode;
        self._state.title = args.title;

        self._init();
    };

    _elems = {
        $content  : $(),
        $cashback : $(),
        $cancel   : $(),
        $modal    : $(),
        $form     : $()
    };

    _const = {
        entities : 'cash',
        entity   : 'cash'
    };

    _state = {
        mode        : '',
        title       : '',
        items       : '',
        cashback    : false,
        breadcrumbs : {}
    };

    _list = () => {
        let self = this;

        Request.send({
            path: '/api/pages/' + self._const.entities,
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items   = response[self._const.entities];

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Профиль',
                            href  : '#'
                        },
                        {
                            title : self._state.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._state.mode, {
                    breadcrumbs : self._state.breadcrumbs,
                    view        : Vars.views.tile,
                    columns     : 2,
                    entity      : self._const.entity,
                    entities    : self._const.entities,
                    actions     : false,
                    group       : false,
                    items       : self._state.items,
                    item_id     : 'entity',
                    detail      : true,
                    card        : function(entity, item){
                        return Utils.renderProfileTemplate('default', {
                            item : item,
                            mode : self._state.mode
                        });
                    }
                }));
            }
        });
    };

    _item = () => {
        let self = this;

        Request.send({
            path: '/api/pages/' + self._const.entities + '/balance',
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.item = response.tariff;

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Профиль',
                            href  : '#'
                        },
                        {
                            title : 'Мой кошелёк',
                            href  : '#cash'
                        },
                        {
                            title : self._state.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._state.mode, {
                    breadcrumbs : breadcrumbs,
                    entity      : 'tariff',
                    item        : self._state.item,
                    card        : function(entity, item){
                        return Utils.renderProfileTemplate('balance', {
                            tariff : item,
                            mode   : self._state.mode
                        });
                    }
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _initForm = () => {
        let self = this;

        const fields = {
            summ : {
                title     : 'Размер выводимых средств (руб.)',
                type      : Vars.fields.number,
                required  : true,
                value     : self._state.item.balance,
                min       : 1,
                max       : self._state.item.balance
            }
        };

        self._elems.$modal = new Modal({
            title   : self._state.cashback ? 'Отправка заявки на вывод средств' : 'Отмена заявку на на вывод средств',
            content : Utils.renderProfileTemplate('form', {
                item   : self._state.item,
                entity : self._const.entity,
                fields : self._state.cashback ? fields : false,
                buttons : {
                    one : {
                        title : self._state.cashback ? 'Отправить' : 'Отменить заявку',
                        type  : 'submit',
                        class : 'confirm button--remove'
                    },
                    two : false
                }
            }),
            confirm : function(args) {
                self._bindConfirm(args);
            }
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;

        self._elems.$cashback = self._elems.$content.find('.js-balance-cashback');
        self._elems.$cancel   = self._elems.$content.find('.js-balance-cashback-cancel');
    };

    _bindConfirm = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        Request.send({
            path   : '/api/payments/cashback' + (!self._state.cashback ? '/cancel' : ''),
            method : 'POST',
            data   : $form.serialize(),
            done   : function (response) {
                loader.decrease();
                $modal.trigger('close');

                self._state.item = response.tariff;

                let breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Профиль',
                            href  : '#'
                        },
                        {
                            title : 'Мой кошелёк',
                            href  : '#cash'
                        },
                        {
                            title : self._state.title
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._state.mode, {
                    breadcrumbs : breadcrumbs,
                    entity      : 'tariff',
                    item        : self._state.item,
                    card        : function(entity, item){
                        return Utils.renderProfileTemplate('balance', {
                            tariff : item,
                            mode   : self._state.mode
                        });
                    }
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _bindUI = () => {
        let self = this;

        self._elems.$cashback.length && self._elems.$cashback.on('click', function(e) {
            e.preventDefault();
            self._state.cashback = true;
            self._initForm();
        });

        self._elems.$cancel.length && self._elems.$cancel.on('click', function(e) {
            e.preventDefault();
            self._state.cashback = false;
            self._initForm();
        });
    };

    _init = () => {
        let self = this;

        self._bindElements();
        if(!self._elems.$content.length) return;

        if (self._state.mode === Vars.view.list) {
            self._list();
        } else if (self._state.mode === Vars.view.item) {
            self._item();
        }
    }
}

export default Cash;